import { useToast } from 'primevue/usetoast'
import type { TToastMessage } from './types'

/**
 * `useToast()` with `add` retyped to support the additional Nashville fields (`id`, `headerTitle`, `actionLabel`, the icons) to TToast's message shape.
 */
export function useTToast() {
  const toast = useToast()

  return {
    ...toast,
    /**
     * Push a message onto a TToast stack.
     * @param message - The message to render.
     */
    add: (message: TToastMessage) => toast.add(message),
    /**
     * Take a message off a TToast stack.
     * @param message - The message to remove, identified by `id`.
     */
    remove: (message: TToastMessage) => toast.remove(message),
  }
}
